import { AlertTriangle } from "lucide-react";

export function StaleBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-0.5 text-xs font-medium text-red-700">
      <AlertTriangle className="h-3 w-3" /> Stale
    </span>
  );
}
